export default __webpack_public_path__ + "static/media/pvalley.14fb51ec.png";